import { useEffect, useState } from 'react';
import {
  prepareGlassArtwork,
  type PreparedGlassArtwork,
} from '../../assets/prepareGlassArtwork';

export function useGlassArtwork(
  publicPath: string | null,
  idPrefix: string
): PreparedGlassArtwork | null {
  const [artwork, setArtwork] = useState<PreparedGlassArtwork | null>(null);

  useEffect(() => {
    let cancelled = false;
    let objectUrl: string | null = null;
    setArtwork(null);
    if (!publicPath || typeof fetch !== 'function') return undefined;

    fetch(publicPath, { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to load ${publicPath}`);
        return response.text();
      })
      .then((text) => {
        if (cancelled) return;
        const prepared = prepareGlassArtwork(text, idPrefix);
        if (!prepared) {
          setArtwork(null);
          return;
        }
        if (typeof URL.createObjectURL === 'function') {
          objectUrl = URL.createObjectURL(new Blob([prepared.paintSvg], { type: 'image/svg+xml' }));
        }
        if (cancelled) {
          if (objectUrl) URL.revokeObjectURL(objectUrl);
          return;
        }
        setArtwork({ ...prepared, href: objectUrl ?? undefined });
      })
      .catch(() => {
        if (!cancelled) setArtwork(null);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [idPrefix, publicPath]);

  return artwork;
}
